import axios, { authHeader } from "../../services/HTTPService";
import * as action from "../reducers/recipeReducer";
const API_URL = process.env.REACT_APP_API_URL;

export const reOrder = async (dispatch, body, filterParams) => {
  return axios
    .put(API_URL + `/api/recipes/reorder`, body, { headers: authHeader() })
    .then(({ data }) => {
      fetchAll(dispatch, filterParams);
    })
    .catch((error) => {
      dispatch(
        action.setRecipeError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const fetchAll = async (
  dispatch,
  { fieldTofilter, filter, fieldToSort, sortDirection, page, pageSize } = {
    fieldTofilter: "name",
    filter: "",
    fieldToSort: "order",
    sortDirection: "desc",
    page: 1,
    pageSize: 8,
  }
) => {
  dispatch(action.setListLoading(true));

  return axios
    .get(API_URL + `/api/recipes/backoffice/search`, {
      headers: authHeader(),
      params: {
        fieldTofilter,
        filter,
        fieldToSort,
        sortDirection,
        page,
        pageSize,
      },
    })
    .then(({ data }) => {
      const meta = data?.meta;
      dispatch(action.setRecipeList({ data }));
      dispatch(action.setMetadata({ meta }));
      dispatch(action.setListLoading(false));
    })
    .catch((error) => {
      dispatch(
        action.setRecipeError({ error: error?.response?.data?.error?.message })
      );
      dispatch(action.setListLoading(false));
    });
};

export const fetchDetails = async (dispatch, id) => {
  return axios
    .get(API_URL + `/api/recipes/${id}`, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setRecipeDetail({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setRecipeError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const create = async (dispatch, body) => {
  return axios
    .post(API_URL + "/api/recipes", body, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setRecipe({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setRecipeError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const update = async (dispatch, id, body) => {
  return axios
    .put(API_URL + `/api/recipes/${id}`, body, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setRecipe({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setRecipeError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const remove = async (dispatch, id, params) => {
  return axios
    .delete(API_URL + `/api/recipes/${id}`, { headers: authHeader() })
    .then(async () => {
      await fetchAll(dispatch, params);
    })
    .catch((error) => {
      dispatch(
        action.setRecipeError({ error: error?.response?.data?.error?.message })
      );
    });
};
